<template>
   <div>
       <input
        type="text"
        v-model="displayValue"
        :disabled="disabled"
        @blur="whenLeaveField(), isInputActive = false"
        @focus="isInputActive = true"
        onKeyPress="if(this.value.length==12) return false;"/>
    </div>
</template>

<script>
    export default {
        name: 'currency-input',
        props: {
            value: {
                type: Number
            },
            disabled: {
                type: Boolean
            }
        },
        data () {
            return {
                newValue: null,
                isInputActive: false
            }
        },
        computed: {
            displayValue: {
                get: function () {
                    if (this.value !== null) {
                        if (this.isInputActive) {
                            return this.value.toString()
                        } else {
                            return this.$options.filters.convertToLocalStringDK(this.value)
                        }
                    }
                },
                set: function (modifiedValue) {
                    this.newValue = modifiedValue
                }
            }
        },
        methods: {
            whenLeaveField () {
                let val = this.newValue ? this.newValue : this.value
                if (typeof val === 'string') {
                    val = val.replace(',', '.')
                }
                this.$emit('assign-new-asset-value', isFinite(val) ? parseFloat(parseFloat(val).toFixed(2)) : 0)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/currency-input/currency-input.vue